var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysisExplorer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.243 16.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 14.414v2H0v-2h4zm14 0v2H6v-2h12zm1.121-12.95a5.002 5.002 0 01.634 6.298c.024.02.05.042.073.066L21.95 9.95a1 1 0 11-1.414 1.414l-2.122-2.121-.066-.074a5.002 5.002 0 01-6.298-7.705 5 5 0 017.071 0zM4 9.414v2H0v-2h4zm6 0l2.5 2H6v-2h4zm3.464-6.535a3 3 0 104.243 4.242 3 3 0 00-4.243-4.242zM4 4.414v2H0v-2h4zm5 0v2H6v-2h3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisExplorer);
export default __webpack_public_path__ + "static/media/AnalysisExplorer.11f14d118a774dd56c7a3b7fa18d0fbb.svg";
export { ForwardRef as ReactComponent };